import * as R from 'ramda';
import { sortOptionIndex, sortOptionsOrdered } from '../settings';

export const getStringSearchParams = (index) =>
  R.pipe(R.pluck('id'), R.move(index, 0), R.join(', '))(sortOptionsOrdered);
export const sortedStringParams = (index) =>
  getStringSearchParams(index || sortOptionIndex);
